import React, { useState, useRef } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { areaAPI } from '../services/api';
import useRiseIn from '../hooks/useRiseIn';
import styles from './AreaForm.module.css';

const AreaForm = ({ onAreaAdded }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const rootRef = useRef(null);
  useRiseIn(rootRef, { delay: 0.2 });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    setLoading(true);
    try {
      await areaAPI.create(name);
      setName('');
      setOpen(false);
      if (onAreaAdded) onAreaAdded();
    } catch (error) {
      console.error('Error creating area:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      ref={rootRef}
      onClick={() => !open && setOpen(true)}
      className={`${styles.root} ${open ? styles.rootOpen : styles.rootClosed}`}
    >
      {!open ? (
        <Typography className={styles.prompt}>
          {t('areas.newArea')}
        </Typography>
      ) : (
        <Box
          component="form"
          onSubmit={handleSubmit}
          className={styles.form}
          onClick={(e) => e.stopPropagation()}
        >
          <TextField
            fullWidth
            size="small"
            placeholder={t('areas.namePlaceholder')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            autoFocus
            className={styles.nameField}
          />
          <Box className={styles.actions}>
            <Button
              type="submit"
              size="small"
              variant="contained"
              disabled={loading || !name.trim()}
              className={styles.submitBtn}
            >
              {loading ? t('areas.addingArea') : t('areas.addArea')}
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                setOpen(false);
                setName('');
              }}
              disabled={loading}
              className={styles.cancelBtn}
            >
              {t('common.cancel')}
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AreaForm;
